import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../../common/button";
import LottieAnimation from "../../common/animations";
import * as animationData from "../../../json/Congratulation Badge Confetti.json";

const typedAnimationData: JSON = animationData as unknown as JSON;
interface Badge {
  module_id: string;
  badge_icon: string;
  is_completed: boolean;
  badge_name: string;
}

export default function CongratulationsScreen() {
  const [currentState, setCurrentState] = useState(0);
  const location = useLocation();
  const { badges, newlyAddedBadge } = location.state || {};

  const [isColorful, setIsColorful] = useState(false);

  useEffect(() => {
    if (currentState === 1) {
      const timer = setTimeout(() => {
        setIsColorful(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [currentState]);

  const handleNext = () => {
    if (currentState < 2) {
      setCurrentState(currentState + 1);
    } else {
      window.history.back();
    }
  };

  const renderBadges = () => {
    if (currentState === 0) {
      return (
        <div className="flex justify-center relative">
          <img
            src={newlyAddedBadge.badge_icon}
            alt="Newly Added Badge"
            className="w-56 h-56 relative z-10"
          />
        </div>
      );
    } else {
      return (
        <div className="flex flex-col items-center gap-4 mb-6">
          <div className="flex justify-center gap-4 flex-wrap">
            {badges.map((badge: Badge) => (
              <img
                key={badge.module_id}
                src={badge.badge_icon}
                alt="Badge"
                className={`w-20 h-20 transition-all duration-700 ease-in-out ${
                  badge.module_id === newlyAddedBadge.module_id
                    ? `${
                        isColorful
                          ? "grayscale-0 text-blue-600"
                          : "grayscale text-gray-400"
                      }`
                    : badge.is_completed
                      ? ""
                      : "grayscale"
                }`}
              />
            ))}
          </div>
        </div>
      );
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center px-4 pt-12 text-white relative">
      {currentState === 0 && (
        <div className="absolute left-1/2 transform -translate-x-1/2 ">
          <LottieAnimation
            type="json"
            jsonData={typedAnimationData}
            height="600px"
            width="500px"
          />
        </div>
      )}

      <h1 className="text-[64px] md:text-6xl font-semibold mb-10 pt-12">
        Congratulations!
      </h1>

      <div className="transition-all duration-300 ease-in-out mt-8 mb-4">
        {renderBadges()}
      </div>

      {/* Badge Text */}
      <div className="text-center mb-6">
        <h2 className="text-3xl md:text-4xl font-semibold mb-2 bg-gradient-text text-transparent bg-clip-text">
          {newlyAddedBadge.badge_name}
        </h2>
        <p className="text-3xl md:text-4xl font-semibold text-[#D4B886]">
          Badge!
        </p>
      </div>

      {/* Score Indicators */}
      <div className="flex items-center gap-4 mb-10">
        <div className="flex items-center gap-2">
          <img src="/assets/icons/star-red.png" alt="" className="w-8 h-8" />
          <span className="text-2xl">50</span>
        </div>
      </div>

      {/* Next Button */}
      <Button
        onClick={handleNext}
        customClasses={`px-[70px] py-2 !rounded-[8px] cursor-pointer`}
      >
        Next
      </Button>
    </div>
  );
}
